export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy hh:mm';
export const TIME_FORMAT = 'HH:mm';

export const dateOfNextMonth = (): Date => {
  const now = new Date();
  const nextMonth =
    now.getMonth() == 11
      ? new Date(now.getFullYear() + 1, 0, 1)
      : new Date(now.getFullYear(), now.getMonth() + 1, 1);
  return nextMonth;
};

export const getDateAgoByMonth = (month: number = 0): Date => {
  let d = new Date();
  d.setMonth(d.getMonth() - month);
  return d;
};
